<h1 mat-dialog-title>
  <mat-icon>error_outline</mat-icon>
  <span [innerHtml]="title"></span>
</h1>
<div mat-dialog-content [innerHtml]="message"></div>
<div mat-dialog-actions>
  <button mat-raised-button (click)="notOk()" class="small">No</button>
  <button mat-raised-button color="primary" (click)="ok()" class="small">Yes</button>
</div>
